import React, { useState } from "react";
import AffiliateRegister from "../components/AffiliateRegister";
import { ArrowLeft } from "lucide-react";
import downArrow from "../assets/downArrow.png";
import affProg from "../assets/affProg.png";
import AF1 from "../assets/AF1.png";
import AF2 from "../assets/AF2.png";
import AF3 from "../assets/AF3.png";

export default function AffiliateProgram() {
  const [showRegister, setShowRegister] = useState(false);

  return (
    <div className="min-h-screen lg:bg-black bg-[#191919] p-6">
      {showRegister && (
        <AffiliateRegister
          onClose={() => setShowRegister(false)}
          showLogin={() => setShowRegister(false)}
        />
      )}

      <div className="">
        <button className="flex items-center text-white gap-2 hover:opacity-80">
          <ArrowLeft className="w-5 h-5" />
          <span>Back</span>
        </button>
      </div>

      <div className="max-w-5xl mx-auto space-y-12">
        <h1 className="text-4xl md:text-6xl font-monument font-extrabold text-primary text-center tracking-wider">
          AFFILIATE PROGRAM
        </h1>

        <div className="flex flex-col items-center gap-6">
          <button

            className="bg-primary hover:bg-primary/90 text-black px-12 py-3 rounded-full font-semibold flex items-center gap-2 text-lg"
          >
            <span className="text-2xl">🎮</span>
            Lets Earn
          </button>
          <img src={downArrow} alt="Arrow Down" className="h-7" />
        </div>

        <div className="bg-zinc-900/50 rounded-2xl p-8 space-y-8 backdrop-blur-sm border border-white">
          <div

            className="bg-primary text-black p-4 rounded-lg font-medium text-lg "
          >
            <span onClick={() => setShowRegister(true)} className="underline cursor-pointer hover:text-yellow-900">Sign Up</span> to join the Futcoinspot Affiliate Program
          </div>


          <div className="text-primary space-y-6">
            <h2 className="text-2xl font-bold flex items-center gap-2">
              How can you boost your earnings? 🚀
            </h2>

            <div className="flex gap-4 items-start">
              <div className="w-12 h-12 flex-shrink-0">
                <img
                  src={AF1}
                  alt="Robot with coin"
                  className="w-full h-full"
                />
              </div>
              <p className="text-lg">
                Refer your exclusive code among friends and family and get an{" "}
                <span className="font-bold">extra discount</span>
              </p>
            </div>

            <div className="flex gap-4 items-start">
              <div className="w-12 h-12 flex-shrink-0">
                <img
                  src={AF3}
                  alt="Video icon"
                  className="w-full h-full"
                />
              </div>
              <p className="text-lg">
                Share your exclusive FIFA discount code in your social posts—
                just make sure our site takes center stage in your videos so
                everyone knows where to grab their deal!
              </p>
            </div>

            <div className="flex items-center gap-2 font-bold text-xl">
              Earn Now! 💰
            </div>
          </div>
        </div>

        <div className="bg-primary rounded-xl p-8 border border-white flex items-center gap-4">
          <div className="w-16 h-16 flex-shrink-0">
            <img src={AF2} alt="Money bag" className="w-full h-full" />
          </div>
          <div className="font-bold text-2xl text-black">
            Earn up to 5% commission for every order placed using your discount code
          </div>
        </div>

        <div className="relative h-64 rounded-xl overflow-hidden">

          <div className="h-56 relative lg:h-48 rounded-xl lg:border lg:border-white overflow-hidden ">
            <img
              src={affProg}
              alt="Stadium crowd"
              className=" w-full  lg:absolute lg:inset-0 lg:w-full lg:h-full lg:object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
